import { AbstractControl, ValidatorFn } from '@angular/forms';

export function israelPhoneNumberValidator(minLength: number = 7, maxLength: number = 10): ValidatorFn {
	return (control: AbstractControl): { [key: string]: any } | null => {
		const value = control.value;
		if (!value) return null;

		const digitsOnly = /^\d+$/;
		if (!digitsOnly.test(value)) {
			return { 'invalidPhoneNumber': { message: 'Phone number must contain digits only.' } };
		}

		if (value.length < minLength || value.length > maxLength) {
			return { 'invalidPhoneNumberLength': { message: `Phone number must be between ${minLength} and ${maxLength} digits.` } };
		}

		return null;
	};
}
